import type { OnboardingChatMessage, SiteOnboardingDraft } from './onboarding-types';

export type CanvasSessionPhase =
  | 'idle'
  | 'onboarding'
  | 'generating'
  | 'complete'
  | 'editing'
  | 'publishing'
  | 'error';

export interface SessionArtifact {
  id: string;
  kind:
    | 'generation-event'
    | 'assistant-message'
    | 'user-message'
    | 'edit-request'
    | 'edit-result'
    | 'publish-result';
  label: string;
  payload: unknown;
  createdAt: number;
}

/** In-memory working buffer before draft is persisted via edit executor. */
export interface EditWorkingBuffer {
  instruction: string;
  page: string;
  updatedAt: number;
}

/** Durable siteId-keyed session (brief + generation + conversation + artifacts). */
export interface CanvasSessionRecord {
  siteId: string | null;
  generationSessionId: string | null;
  draft: SiteOnboardingDraft;
  messages: OnboardingChatMessage[];
  artifacts: SessionArtifact[];
  phase: CanvasSessionPhase;
  lastError: string | null;
  editWorkingBuffer: EditWorkingBuffer | null;
  publishedUrl: string | null;
  updatedAt: number;
}

export interface GenerationIntentDetail {
  path: string;
  query: string;
  focus: string;
}

export const CANVAS_SESSION_STORAGE_PREFIX = 'landi-canvas-session:';
